import { render, staticRenderFns } from "./com-page-orders.vue?vue&type=template&id=3de11236&"
import script from "./com-page-orders.vue?vue&type=script&lang=js&"
export * from "./com-page-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports